module.exports = __webpack_public_path__ + "static/img/package-icon-1.df2ba689.png";